import React, { useEffect, useState } from 'react';
import { PrimaryButton, Colors } from 'library';
import { Grid } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { FacebookIcon, FacebookShareButton } from 'react-share';
import { client, consoleLogInDev, track } from 'shared';
import { PastProvider } from './models';
import { getCopy } from './referralCopy';
import { useUserContext } from 'UserContext';

const ReferralFacebook = ({
    referredProvider,
    link,
    referralContext,
}: {
    referredProvider: PastProvider;
    link: string;
    referralContext: string;
}) => {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(false);
    const [reid, setReid] = useState<number>();
    const { user } = useUserContext();
    const location = useLocation();

    useEffect(() => {
        setContent(getCopy(referredProvider));
    }, [referredProvider, link]);

    function onClick() {
        setLoading(true);
        client('tracking/api/referral-engagement/', {
            method: 'POST',
            body: { user: user?.id, path: location.pathname, context: referralContext },
        })
            .then((response) => {
                setReid(response.id);
            })
            .catch(consoleLogInDev)
            .finally(() => {
                setLoading(false);
            });
        track('Referrals: Shared via Facebook', {
            sitter: referredProvider?.id > 0 ? referredProvider.babysitter_id : null,
        });
    }

    return (
        <Grid container direction="column" style={{ marginTop: 30 }}>
            <FacebookShareButton
                style={{ marginRight: 10, width: 'fit-content' }}
                openShareDialogOnClick
                children={
                    <PrimaryButton
                        buttonStyle={{ marginBottom: 12, width: 'fit-content' }}
                        onClick={onClick}
                        loading={loading}
                        disabled={loading}
                    >
                        <div>
                            <FacebookIcon
                                bgStyle={{ fill: Colors.white }}
                                iconFillColor={Colors.darkNavy}
                                round
                                size={28}
                                style={{ marginRight: 10 }}
                            />
                            Share on Facebook
                        </div>
                    </PrimaryButton>
                }
                url={!!reid ? `${link}&reid=${reid}` : link}
                quote={content}
            />
        </Grid>
    );
};

export default ReferralFacebook;
